// Een verwijzing naar een andere notitie, als blokje in de tekst.
//
// De link bewaart het id van de notitie en de titel zoals die op dat moment was. Het id is
// wat telt: hernoem je de andere notitie, dan blijft de link werken. Dat is precies waar
// Obsidian's bestandsnaam-links op stuklopen.

import { Node, mergeAttributes, InputRule } from "@tiptap/core";

export type NotitieLinkOpties = {
  /** Wordt aangeroepen als iemand `[[` typt: de app opent dan de notitiekiezer. */
  opZoeken?: () => void;
  /** Wordt aangeroepen bij een klik op een link. */
  opOpenen?: (id: string) => void;
};

export const NotitieLink = Node.create<NotitieLinkOpties>({
  name: "notitieLink",
  group: "inline",
  inline: true,
  atom: true,
  selectable: true,

  addOptions() {
    return { opZoeken: undefined, opOpenen: undefined };
  },

  addAttributes() {
    return {
      id: { default: "" },
      titel: { default: "" }
    };
  },

  parseHTML() {
    return [{ tag: "span[data-notitie]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-notitie": node.attrs.id,
        class: "notitielink",
        title: "Open deze notitie"
      }),
      `${node.attrs.titel || "Zonder titel"}`
    ];
  },

  renderText({ node }) {
    return node.attrs.titel || "";
  },

  addInputRules() {
    return [
      new InputRule({
        // Zodra iemand `[[` typt, halen we die twee tekens weer weg en openen we de kiezer.
        // Zo hoeft er geen tweede zoekpopup in de editor te leven: de app heeft er al een.
        find: /\[\[$/,
        handler: ({ range, chain }) => {
          chain().deleteRange(range).run();
          this.options.opZoeken?.();
        }
      })
    ];
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-k": () => {
        this.options.opZoeken?.();
        return true;
      }
    };
  }
});
